import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPipe: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconPipe"><Path d="M9 19.5H10.5V11.5H19V19.5H21C21.4142 19.5 21.75 19.8358 21.75 20.25C21.75 20.6642 21.4142 21 21 21H3C2.58579 21 2.25 20.6642 2.25 20.25C2.25 19.8358 2.58579 19.5 3 19.5H5V11.5H9V19.5Z" fill="currentColor"/><Path d="M7 10H3.75C3.33579 10 3 9.66421 3 9.25V3.75C3 3.33579 3.33579 3 3.75 3H7V10Z" fill="currentColor"/><Path d="M20.25 3C20.6642 3 21 3.33579 21 3.75V9.25C21 9.66421 20.6642 10 20.25 10H8.5V3H20.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPipe;
